// Where a widget someone adds goes on a slides board: on the open slide when it is a Widget slide waiting for one,
// else on a new Widget slide right after the open slide, opened, the widget and its slide in one step. The gallery's
// Add, Connect's and every other add come through here (src/state/actions.ts addWidget). A deck has no shelf: its
// widgets live on its slides.

import { newId, randomString } from "../../../shared/ids";
import type { SlideBox } from "../../../shared/slideDesign";
import { useDesign } from "./design/store";
import { orderAt } from "../../../shared/entries";
import { slideOf, slidesOf } from "../../../shared/slides";
import type { Board, Entry, Op, WidgetItem } from "../../../shared/types";
import { boardEntries, get } from "../../state/store";
import type { Placement } from "../kinds";
import { openOf, openSlide, useSlidesUi } from "./state";

export function placeOnSlide(item: WidgetItem, board: Board): Placement {
  const slides = slidesOf(boardEntries(get(), board.id));
  const open = openOf(slides, useSlidesUi.getState().open[board.id]);
  const placed: WidgetItem = { ...item, x: 0, y: 0 };
  const s = open ? slideOf(open) : null;
  // asked for from the bar's Widget (S5): a box on the open slide, in its middle, over what is there
  if (open && s && useDesign.getState().widgetTo === open.id) {
    useDesign.setState({ widgetTo: null });
    const z = Math.max(0, ...(s.boxes ?? []).map((b) => b.z)) + 1;
    const box: SlideBox = { id: "b" + randomString(9), kind: "widget", x: 420, y: 230, w: 760, h: 440, z, widget: item.id, radius: 16 };
    queueMicrotask(() => useDesign.setState({ slide: open.id, sel: [box.id], typing: null, zone: "slide" }));
    return { ops: [{ op: "item.put", item: placed }, { op: "entry.put", entry: { ...open, data: { ...open.data, boxes: [...(s.boxes ?? []), box] } } }] };
  }
  // the open Widget slide waiting for its widget takes it
  if (open && s?.layout === "widget" && !(s.widget && get().items[s.widget])) {
    return { ops: [{ op: "item.put", item: placed }, { op: "entry.put", entry: { ...open, data: { ...open.data, widget: item.id } } }] };
  }
  const at = open ? slides.indexOf(open) + 1 : slides.length;
  const slide: Entry = { id: newId("e_"), boardId: board.id, t: "slide", parent: null, order: orderAt(slides, at), data: { layout: "widget", title: item.title || "", body: null, widget: item.id }, createdAt: Date.now(), updatedAt: Date.now(), by: null };
  // the new slide opens once the step is made
  queueMicrotask(() => openSlide(board.id, slide.id));
  const ops: Op[] = [
    { op: "item.put", item: placed },
    { op: "entry.put", entry: slide },
  ];
  return { ops };
}
